/* eslint-disable no-nested-ternary */
import { Button, Icons, LoadingIndicator } from '@components';
import { BeneficiariosService } from '@services/beneficiarios';
import { isEqual } from '@utils';
import update from 'immutability-helper';
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { obterFormulariosRequest } from '../../../../store/modules/requerimento/actions';
import { Beneficiario } from './Beneficiario';

const REFERENCIA_BENEFICIARIOS_RCM =
  'RequerimentoAvaliacaoInscricaoAlteracaoBeneficiosRCM';

export const Beneficiarios = () => {
  const [loading, setLoading] = useState(true);
  const [beneficiarios, setBeneficiarios] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const users = useSelector((state) => state.user);

  const { allForms: formularios, allFormsRequestDone } = useSelector(
    (state) => state.requerimento
  );

  const formularioBeneficiariosRCM = useMemo(
    () =>
      formularios.find((f) => f.referencia === REFERENCIA_BENEFICIARIOS_RCM),
    [formularios]
  );

  const isBeneficiariosRCMHabilitado =
    formularioBeneficiariosRCM?.habilitado ?? false;

  useEffect(() => {
    if (!allFormsRequestDone) {
      dispatch(obterFormulariosRequest());
    }
  }, [allFormsRequestDone, dispatch]);

  const getBeneficiarios = useCallback(() => {
    const service = new BeneficiariosService();
    service
      .getBeneficiarios(users.matricula, users.plano)
      .then((dados) => {
        if (dados.data.ObterBeneficiariosParticipanteResult === null) {
          setLoading(false);

          return;
        }
        const dadosBeneficiarios =
          dados.data.ObterBeneficiariosParticipanteResult.Beneficiario;
        const dadosBeneficiariosModel = [];
        if (dadosBeneficiarios.length === undefined) {
          const nomeSegregado = dadosBeneficiarios.CodigoNome.split(' - ');
          dadosBeneficiariosModel.push({
            id: nomeSegregado[0],
            nome: nomeSegregado[1],
            nascimento: dadosBeneficiarios.DataNascimento,
            parentesco: dadosBeneficiarios.Parentesco,
            situacao: dadosBeneficiarios.Situacao,
          });
        } else {
          dadosBeneficiarios.forEach((item) => {
            const nomeSegregado = item.CodigoNome.split(' - ');
            dadosBeneficiariosModel.push({
              id: nomeSegregado[0],
              nome: nomeSegregado[1],
              nascimento: item.DataNascimento,
              parentesco: item.Parentesco,
              situacao: item.Situacao,
            });
          });
        }
        setBeneficiarios(dadosBeneficiariosModel);

        setLoading(false);
      })
      .catch(() => {
        toast.error('Erro ao recuperar os dados');
        setLoading(false);
      });
  }, [users.matricula, users.plano]);

  const changeBeneficiario = (object, index) => {
    if (!isEqual(beneficiarios[index], object)) {
      const arr = update(beneficiarios, {
        $splice: [[index, 1, object]],
      });
      setBeneficiarios(arr);
    }
  };

  useEffect(() => {
    getBeneficiarios();
  }, [getBeneficiarios]);

  const handleIrParaRequerimento = () => {
    if (isBeneficiariosRCMHabilitado && formularioBeneficiariosRCM) {
      navigate(`/requerimentos/novo/${formularioBeneficiariosRCM.destino}`);
    }
  };

  return (
    <>
      {!loading ? (
        beneficiarios.length > 0 ? (
          beneficiarios.map((b, i) => (
            <Fragment key={b.nome}>
              <Beneficiario
                beneficiario={b}
                onChangeBeneficiario={changeBeneficiario}
                index={i}
              />
              {beneficiarios.length - 1 !== i && <hr className="my-4" />}
            </Fragment>
          ))
        ) : (
          <h2 className="mb-3 fw-bold">Não há beneficiários cadastrados.</h2>
        )
      ) : (
        <LoadingIndicator />
      )}
      <hr className="my-4" />
      <div
        className="card shadow-sm border-0 p-4"
        style={{ borderRadius: '12px' }}
      >
        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
          <div>
            <h3 className="fw-bold mb-2">Alteração de Beneficiários (RCM)</h3>
            <p className="mb-0 text-muted">
              Para alterar os beneficiários, favor preencher o requerimento de
              Avaliação para Inscrição / Alteração de Beneficiários para Renda
              Continuada por Morte (RCM), clicando no botão ao lado
            </p>
          </div>
          <div className="d-flex flex-column align-items-center flex-shrink-0">
            <Button
              transparent
              color="orange"
              onClick={handleIrParaRequerimento}
              disabled={loading || !isBeneficiariosRCMHabilitado}
            >
              Ir para Requerimento
            </Button>
            {!isBeneficiariosRCMHabilitado && allFormsRequestDone && (
              <div
                className="d-flex align-items-start gap-2 mt-2 p-2"
                style={{
                  backgroundColor: '#fff3e0',
                  borderRadius: '8px',
                  maxWidth: '280px',
                }}
              >
                <Icons
                  path="warning"
                  size={1.2}
                  style={{ color: '#f9a825', flexShrink: 0 }}
                />
                <span className="ts-12 fw-bold" style={{ color: '#f9a825' }}>
                  Para criar um novo requerimento desse tipo é necessário
                  cancelar o requerimento anterior em andamento.
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
